/** @type {import("./types.js").VisualGuidesCatalog} */
export const visualGuidesNl = {
  "how": {
    "intro": "Van standaardplaat tot werkplan in vier stappen. Onder elke stap zie je waar dat in Plaatplan staat.",
    "steps": [
      {
        "title": "Materiaalvoorraad instellen",
        "body": "Links in de planner kies je materiaal en plaatformaat. Stel zaagbreedte (kerf) en nerfrichting in. Voeg eventueel restmateriaal toe dat je al hebt liggen."
      },
      {
        "title": "Deelprojecten en onderdelen invoeren",
        "body": "Onder de zaagindeling maak je per meubel of klus een deelproject. Voer panelen in via de tabel of met een regel zoals 600×1220×2 zijpaneel."
      },
      {
        "title": "Zaagindeling controleren",
        "body": "In het midden zie je hoe panelen op de platen liggen, kleurgecodeerd per project. Links bij Resultaat staan het aantal platen en de benutting."
      },
      {
        "title": "Werkplan openen",
        "body": "Klik op Exporteren → Werkplan openen. Je gaat naar het werkplan met twee tabs: Voorbereiden (instellen) en Zaagopdracht (meenemen naar de winkel).",
        "note": "/handleiding/werkplan-printen",
        "noteLabel": "Handleiding: Werkplan printen"
      }
    ]
  },
  "werkplanExport": {
    "intro": "Het werkplan is bedoeld om mee te nemen naar de bouwmarkt of zaagservice, of om zelf mee te zaaggen. Je opent het vanuit de planner, stelt alles in onder Voorbereiden, controleert de Zaagopdracht en slaat op als PDF via je browser.",
    "steps": [
      {
        "title": "Werkplan openen",
        "body": "Voeg eerst onderdelen toe in de planner. Klik dan op Exporteren in de header en kies Werkplan openen. Je werkplan opent op een aparte pagina met de tabs Voorbereiden en Zaagopdracht."
      },
      {
        "title": "Voorbereiden",
        "body": "Kies welke platen in de opdracht zitten (nieuwe standaardplaten en/of restmateriaal). Stel zaaginstellingen in, pas per plaat de strategie aan en verfijn de zaaglijst (maten, instructies). Optioneel: controleer de zaagvolgorde op desktop.",
        "note": "/handleiding/zaagvolgorde-controleren",
        "noteLabel": "Handleiding: Zaagvolgorde controleren"
      },
      {
        "title": "Zaagopdracht controleren",
        "body": "Schakel naar de tab Zaagopdracht. Dit is wat je meeneemt of print: zaaglijst, algemene instructie en visuele indeling. Controleer of maten en strategie kloppen vóór je print."
      },
      {
        "title": "Printen of PDF opslaan",
        "body": "Klik op Print / sla op als PDF. De app schakelt automatisch naar Zaagopdracht. In het printvenster van je browser kies je Opslaan als PDF of een printer. Op papier of PDF gaan alleen de werkplanpagina's mee."
      }
    ],
    "sections": [
      {
        "heading": "Wat staat er in het werkplan?",
        "paragraphs": [
          "Zaaglijst met maten, aantallen en kantafwerking per paneel. Visuele indeling per plaat. Eventueel zaagrest of stroken, afhankelijk van de gekozen strategie.",
          "Onder Voorbereiden kun je alles aanpassen. De tab Zaagopdracht toont de schone versie voor de zaagwinkel of je eigen zaagtafel.",
          "Het werkplan is vendor-neutraal: bruikbaar bij Hornbach, Gamma, Karwei of een andere zaagservice."
        ]
      },
      {
        "heading": "Zaagstrategieën",
        "paragraphs": [
          "Efficiënt zagen, grote zaagrest bewaren en stroken leveren veranderen de instructies en het werkplan, niet welke panelen waar op de plaat liggen.",
          "Kies per plaat een strategie als je de zaagservice een andere werkwijze wilt meegeven. Zet Zaagsneden tonen aan om genummerde snedes te zien. Optioneel kun je op desktop de zaagvolgorde stap voor stap controleren."
        ]
      },
      {
        "heading": "Niet hetzelfde als CSV of projectbestand",
        "paragraphs": [
          "CSV is handig voor een spreadsheet of e-mail. Het projectbestand (.json) is je backup om later verder te werken in Plaatplan.",
          "Voor de zaagbalie of je eigen zaagtafel gebruik je het printbare werkplan."
        ]
      }
    ]
  },
  "cutSimulator": {
    "intro": "Controleer thuis op desktop de genummerde zaagvolgorde vóór je print of naar de bouwmarkt gaat. Je vindt deze optie in het werkplan, tab Voorbereiden, bij elke plaat onder Visuele zaagindeling. Op een smal scherm zie je alleen het statische bord.",
    "steps": [
      {
        "title": "Werkplan openen",
        "body": "Open het werkplan via Exporteren → Werkplan openen in de planner. Ga naar de tab Voorbereiden en scroll naar Visuele zaagindeling. De simulator staat per plaat, onder de strategie-instellingen.",
        "note": "/handleiding/werkplan-printen",
        "noteLabel": "Handleiding: Werkplan printen"
      },
      {
        "title": "Zaagsneden aanzetten",
        "body": "Zet bij Zaaginstellingen de optie Zaagsneden tonen (genummerd, per zaagstrategie) aan. Zonder deze optie zie je geen genummerde snedes en kun je de simulator niet gebruiken. De gekozen zaagstrategie bepaalt welke snedes worden getoond."
      },
      {
        "title": "Simulator openen",
        "body": "Boven elke plaatvisual staat een strip Zaagvolgorde controleren. Klik op Volgorde bekijken. Per werkplan-pagina kan er maar één simulator tegelijk open zijn: open je hem op plaat 2, dan sluit hij op plaat 1."
      },
      {
        "title": "Snedes doorlopen",
        "body": "Gebruik Vorige en Volgende, de schuifbalk of ← en → op het toetsenbord. De huidige snede is oranje; eerdere snedes zijn gedimd. Het actieve stuk krijgt een oranje kader; de rest van de plaat wordt gedimd. Onder het bord staat per stap een korte omschrijving van de snede."
      },
      {
        "title": "Sluiten en verder",
        "body": "Druk op Esc of sluit de simulator om terug te gaan naar het statische bord. Controleer daarna de tab Zaagopdracht vóór je print."
      }
    ],
    "sections": [
      {
        "heading": "Waarvoor is dit bedoeld?",
        "paragraphs": [
          "Dit is een voorbereidingshulpmiddel: je ziet in welke volgorde de genummerde snedes logisch uitgevoerd worden en welk deel van de plaat bij elke snede hoort.",
          "Geen live zaagcoach aan de machine. Aan de zaagtafel blijf je zelf verantwoordelijk voor veiligheid en controle."
        ]
      },
      {
        "heading": "Desktop en smalle schermen",
        "paragraphs": [
          "De stap-voor-stap-weergave werkt op een breed scherm (desktop of tablet in landschap). Op telefoon of een smal browservenster zie je wel het plaatschema met genummerde snedes, maar niet de interactieve doorloop."
        ]
      },
      {
        "heading": "Toetsenbord",
        "paragraphs": [
          "← en →: vorige of volgende snede. Esc: simulator sluiten. Toetsen werken alleen als de simulator open is en je niet in een tekstveld typt."
        ]
      },
      {
        "heading": "Strategie en plaat",
        "paragraphs": [
          "De snedes volgen de gekozen zaagstrategie per plaat (efficiënt zagen, grote zaagrest bewaren of stroken leveren). Wissel je strategie of plaat, dan begint de simulator opnieuw bij stap 0.",
          "Bij stroken leveren of als er geen snedes zijn, kan de simulator een korte melding tonen in plaats van stappen."
        ]
      }
    ]
  }
};
